import type { ProfileProgress } from "../progression/levels";
import type { OrbitForgeSave } from "../save/types";
import type { FeedbackDraft } from "../runtime/feedback";
import { cosmeticFeedbackTarget, findCosmeticDefinition, isCosmeticUnlocked, type CosmeticKind } from "./catalog";

export interface EquipCosmeticCommandResult {
  readonly dirty: boolean;
  readonly feedback: readonly FeedbackDraft[];
}

export function runEquipCosmeticCommand(save: OrbitForgeSave, progress: ProfileProgress, kind: CosmeticKind, id: string): EquipCosmeticCommandResult {
  const definition = findCosmeticDefinition(kind, id);
  const target = cosmeticFeedbackTarget(kind, id);
  if (!definition || !isCosmeticUnlocked(definition, save, progress)) {
    return {
      dirty: false,
      feedback: [{ kind: "denied", target }]
    };
  }

  const selectedId = kind === "shellSkin" ? save.cosmetics.SelectedShellSkin : save.cosmetics.SelectedCorePattern;
  if (selectedId === id) {
    return {
      dirty: false,
      feedback: [{ kind: "pulse", target }]
    };
  }

  save.cosmetics = kind === "shellSkin"
    ? { ...save.cosmetics, SelectedShellSkin: id }
    : { ...save.cosmetics, SelectedCorePattern: id };

  return {
    dirty: true,
    feedback: [{ kind: "pulse", target }]
  };
}
